import template from "./pTeam.html";
import moment from "moment";
import * as XLSX from 'xlsx/xlsx.mjs';

export function pTeamDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pTeamController,
    controllerAs: 'pTeam',
    bindToController: true
  };

  return directive;
}

class pTeamController {
  constructor(Auth, Admin, $routeParams, $q, $location, bModal, $scope, $interval,$translate, Notes, DownloadFile, ConnectionQuality) {
    'ngInject';
    this.Auth = Auth;
    this.Admin = Admin;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.$location = $location;
    this.bModal = bModal;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$translate = $translate;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.country = this.$routeParams.name;
    this.teamId = this.$routeParams.teamId;
    this.teamInternal = "Internal";
    this.processInternal = "Internal";
    this.clientSearchText = '';
    this.DownloadFile = DownloadFile;

    this.init();

    this.userFields = {
      fullName: "name",
      emailAddress: "email",
      role: "role",
      canEditAccepted: "checkbox",
      canExportWorklog: "checkbox",
      acceptPersonalWorklogs: "checkbox",
      canImportIncome: "checkbox",
      canImportIncomeCountrywide: "checkbox",
      canViewRates: "checkbox",
      canUpdateRates: "checkbox",
      managementViewHidden: "checkbox",
      canAccess360View: "checkbox",
      canAccessFlexitime: "checkbox",
      isIntegrationAdmin: "checkbox",
      isLocalAdmin: "checkbox",
      isAdmin: "checkbox",
      invoicedTime: "checkbox",
      projectVisibilityFromD365: "checkbox",
      forcePowerUser: "checkbox",
    };

    this.offerCalcFields = {
      fullName: "name",
      calcClientDataAccess: "checkbox",
      calcTemplatesAccess: "checkbox",
      calcTemplatesEditAccess: "checkbox",
      calcOfferBuilderAccess: "checkbox",
      calcGlobalBidsAccess: "checkbox",
      calcPgViewAccess: "checkbox",
      calcPgEditAccess: "checkbox",
      directOClogin: "checkbox",
      calcGlobalTenderManager: "checkbox"
    };

    this.userActions = [
      {
        name: "new",
        functionName: "startAddingUser",
        fa: "fa-plus"
      }
    ];

    this.userRowActions = [
      {
        name: "view",
        functionName: "openUser"
      }
    ];

    this.clientFields = {
      displayName: "info",
      taxId: "info",
      country: "info",
      clientGroupName: "info",
      defaultBillingTypeName: "info"
    };

    this.clientActions = [
      {
        name: "export",
        functionName: "exportClients",
        fa: "fa-download"
      },
      {
        name: "new",
        functionName: "startAddingClient",
        fa: "fa-plus"
      }
    ];

    this.clientRowActions = [
      {
        name: "view",
        functionName: "openClient"
      },
      {
        name: "remove",
        functionName: "removeClient"
      },
      {
        name: 'download_client_notes',
        functionName: 'downloadClientNotes',
        fa: 'fa-download'
      }
    ];

    this.overtimeFields = {
      validFrom: "date",
      managementMode: "info"
    };

    this.overtimeActions = [
      {
        name: "new",
        functionName: "startAddingOvertime",
        fa: "fa-plus"
      }
    ];

    this.overtimeRowActions = [
      {
        name: "edit",
        functionName: "startEditingOvertime"
      }
    ];


    this.newUserData = {
      fullName: {
        type: "text"
      },
      emailAddress: {
        type: "text"
      },
      role: {
        type: "array"
      },
      siteId: {
        type: "select"
      },
      seniorityLevel: {
        type: "select"
      },
      type: {
        type: "array"
      },
      standardWorkingHours: {
        type: "text"
      },
      validFrom: {
        type: "date"
      },
      canEditAccepted: {
        type: "checkbox",
        isNotRequired: true
      },
      canExportWorklog: {
        type: "checkbox",
        isNotRequired: true
      },
      acceptPersonalWorklogs : {
        type: "checkbox",
        isNotRequired: true
      },
      canImportIncome: {
        type: "checkbox",
        isNotRequired: true
      },
      canImportIncomeCountrywide: {
        type: "checkbox_reliant",
        reliantOn: "canImportIncome",
        isNotRequired: true,
        infoTooltip: true
      },
      canViewRates: {
        type: "checkbox",
        isNotRequired: true
      },
      canUpdateRates: {
        type: "checkbox_reliant",
        reliantOn: "canViewRates",
        isNotRequired: true
      },
      managementViewHidden: {
        type: "checkbox",
        isNotRequired: true
      },
      canAccess360View: {
        type: "checkbox",
        isNotRequired: true
      },
      canAccessFlexitime: {
        type: "checkbox",
        isNotRequired: true
      },
      invoicedTime: {
        type: "checkbox",
        isNotRequired: true
      },
      projectVisibilityFromD365: {
        type: "checkbox",
        isNotRequired: true
      },
      forcePowerUser: {
        type: "checkbox",
        isNotRequired: true
      },
      isIntegrationAdmin: {
        type: "checkbox",
        isNotRequired: true
      },
      isLocalAdmin: {
        type: "radio",
        isNotRequired: true
      },
      isAdmin: {
        type: "radio",
        isNotRequired: true
      },
      calcClientDataAccess: {
        type: "checkbox",
        isNotRequired: true
      },
      calcTemplatesAccess: {
        type: "checkbox",
        isNotRequired: true
      },
      calcTemplatesEditAccess: {
        type: "checkbox",
        isNotRequired: true
      },
      calcOfferBuilderAccess: {
        type: "checkbox",
        isNotRequired: true
      },
      calcGlobalBidsAccess: {
        type: "checkbox",
        isNotRequired: true
      },
      calcPgViewAccess:{
        type: "checkbox",
        isNotRequired: true
      },
      calcPgEditAccess: {
        type: "checkbox_reliant",
        reliantOn: "calcPgViewAccess",
        isNotRequired: true
      },
      directOClogin: {
        type: "checkbox",
        isNotRequired: true
      },
      calcGlobalTenderManager: {
        type: "checkbox",
        isNotRequired: true
      }
    };

    this.newUserDialogCardWeekTable = false;

    this.newClientData = {
      name: {
        type: "text"
      },
      taxId: {
        type: "text"
      },
      country: {
        type: "text",
        editionDisabled: true
      }
    };

    this.newOvertimeData = {
      validFrom: {
        type: "date",
      },
      mode: {
        type: "array"
      }
    };

    this.editOvertimeData = {
      mode: {
        type: "array"
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;

        if(this.user.isLocalAdmin) {
          delete this.userFields.isAdmin;
          delete this.userFields.isIntegrationAdmin;
          delete this.userFields.isLocalAdmin;
          delete this.userFields.canAccess360View;
          delete this.userFields.canAccessFlexitime;
          delete this.offerCalcFields.calcGlobalBidsAccess;
          delete this.offerCalcFields.calcPgViewAccess;
          delete this.offerCalcFields.calcPgEditAccess;
          delete this.offerCalcFields.directOClogin;
        }

        let promises = [
          this.Admin.getTeam(this.teamId),
          this.Admin.getCountry(this.country),
          this.Admin.getSuggestedProcessClientConfigurations(this.teamId),
          this.Admin.getProcessCountryConfigurations(this.country)
        ];

        this.$q.all(promises).then(
          (success) => {
            this.teamData = success[0].data;
            this.countryData = promises[1] ? success[1].data : [];
            this.suggestedPCl = promises[2] ? success[2].data : [];
            this.processGroupCountryConfig =  promises[3] ? success[3].data : [];

            this.featureFlags = this.countryData.country.flags;
            this.is360FeatureFlag = this.featureFlags.indexOf("View360") > -1;

            if (!this.featureFlags.includes("D365Integration")) {
              delete this.userFields.invoicedTime;
              delete this.userFields.projectVisibilityFromD365;
              delete this.newUserData.invoicedTime;
              delete this.newUserData.projectVisibilityFromD365;
            }

            const profitCenter = success[0].data.availableProfitCenters.find(s => s.id == this.teamData.team.profitCenterId);
            this.team = this.teamData.team;
            if(profitCenter){
              this.team.name = `${this.team.name} - ${profitCenter.code} - ${profitCenter.name}`;
            }

            this.teams && this.teams.forEach((t, i) => {
              const profitCenter = success[0].data.availableProfitCenters.find(s => s.id == t.profitCenterId);
              this.teams[i].teamName = `${t.teamName} - ${profitCenter.code} - ${profitCenter.name}`;
            });

            this.availableSitesOfTeam = this.user.isLocalAdmin ?  this.teamData.availableSites.filter( site => site.name != "Iterators HQ") : this.teamData.availableSites;

            this.overtimeManagement = this.teamData.overtimeManagementModes;
            this.overtimeManagement.sort((a,b)=> new Date(a.validFrom) - new Date(b.validFrom));
            this.overtimeSelect = {mode:[this.$translate.instant("OVERTIME.MANUAL"), this.$translate.instant("OVERTIME.AUTO"), this.$translate.instant("OVERTIME.DISABLED")]};

            this.users = this.teamData.users;
            this.users.sort((a, b) => a.fullName.localeCompare(b.fullName));
            localStorage.setItem("roedl-admin-users", angular.toJson(this.users));

            if(this.user.isLocalAdmin){
              this.availableRoles = this.teamData.availableRoles.filter( role => role != "GlobalManager");
            } else {
              this.availableRoles = this.teamData.availableRoles;
            }

            this.userSelect = {
              role: this.availableRoles,
              seniorityLevel: {
                valueToAdd: "id",
                valueToShow: "name",
                values: this.teamData.availableSeniorityLevels.map(level => ({id: level, name: this.$translate.instant(`USER.${level}`)}))
              },
              type: ["Worknorm", "Hourly"],
              siteId: {
                valueToAdd: "id",
                valueToShow: "name",
                values: [].concat(this.availableSitesOfTeam)
              }
            };
            var tempRole = this.userSelect.role[1];
            this.userSelect.role[1] = this.userSelect.role[2];
            this.userSelect.role[2] = tempRole;

            // clientOfCountry = clientOfTeam + (clientInternal + clientToAdd)
            this.clientsOfTeam = this.teamData.clients.map((client => {
              const displayName = (client.additionalInfo ? "(" + client.additionalInfo + ") " : "") + client.name;
              return {...client, displayName };
            }));
            this.clientsOfTeam.sort((a, b) => a.name.localeCompare(b.name));
            localStorage.setItem("roedl-admin-clients", angular.toJson(this.clientsOfTeam));

            this.clientsOfCountry = this.countryData.clients;

            if (this.clientsToAddD) delete this.clientsToAddD;
            this.clientsToAdd = angular.copy(this.clientsOfCountry)
              .filter( c => !(this.clientsOfTeam.find( client => client.id == c.id)))
              .filter( c => c.name != this.teamInternal)
              .map( c => {return {
                name: c.name,
                id: c.id,
                selected: false,
                additionalInfo: c.additionalInfo,
                clientNameWithAdditionalInfo: (c.additionalInfo ? "(" + c.additionalInfo + ") " : "") + c.name
              };
            });
            this.clientInternal = this.clientsOfTeam.find( t => t.name == this.teamInternal) ? {} : angular.copy(this.clientsOfCountry).find(c => c.name == this.teamInternal);
            this.showInternalPGC = this.clientInternal && this.clientInternal.selected;

            // countryPGC = internalPGC + suggestedPGC + unusedPGC
            this.countryProcessGroupConfig = angular.copy(this.processGroupCountryConfig);
            this.internalProcessGroupConfig = this.countryProcessGroupConfig.filter( ipgc => ipgc.idName == this.processInternal);
            this.suggestedProcessGroupConfig = angular.copy(this.suggestedPCl).filter( spgc => spgc.idName != this.processInternal);
            this.unusedProcessGroupConfig = angular.copy(this.countryProcessGroupConfig);
            if(this.suggestedProcessGroupConfig.length > 0){
              for(var i = this.countryProcessGroupConfig.length - 1; i >= 0; i--) {
                if(this.suggestedProcessGroupConfig.find(spcc => {
                  if (spcc.groupConfiguration.id == this.countryProcessGroupConfig[i].groupConfiguration.id) {
                    return true;
                  }
                })) {
                  this.unusedProcessGroupConfig.splice(i, 1);
                }
              }
            }
            this.unusedProcessGroupConfig = this.unusedProcessGroupConfig.filter( spgc => spgc.idName != this.processInternal);

            this.processesToAdd = [];

            this.isFlexibleWorknormFF = this.featureFlags.indexOf("FlexibleWorknormManagement") > -1;
            if(this.isFlexibleWorknormFF) {
              this.dialogCardWidth = "wider";
              this.newUserDialogCardWeekTable = {
                standardWorkingHours: "label",
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: true,
                sun: true
              };
              this.newUserData = {
                fullName: {
                  type: "text"
                },
                emailAddress: {
                  type: "text"
                },
                role: {
                  type: "array"
                },
                siteId: {
                  type: "select"
                },
                seniorityLevel: {
                  type: "select"
                },
                type: {
                  type: "array"
                },
                standardWorkingHours: {
                  type: "label"
                },
                mon: {
                  type: "text"
                },
                tue: {
                  type: "text"
                },
                wed: {
                  type: "text"
                },
                thu: {
                  type: "text"
                },
                fri: {
                  type: "text"
                },
                sat: {
                  type: "text"
                },
                sun: {
                  type: "text"
                },
                validFrom: {
                  type: "date"
                },
                canEditAccepted: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canExportWorklog: {
                  type: "checkbox",
                  isNotRequired: true
                },
                acceptPersonalWorklogs: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canImportIncome: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canImportIncomeCountrywide: {
                  type: "checkbox_reliant",
                  reliantOn: "canImportIncome",
                  isNotRequired: true,
                  infoTooltip: true
                },
                canViewRates: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canUpdateRates: {
                  type: "checkbox_reliant",
                  reliantOn: "canViewRates",
                  isNotRequired: true
                },
                managementViewHidden: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canAccess360View: {
                  type: "checkbox",
                  isNotRequired: true
                },
                canAccessFlexitime: {
                  type: "checkbox",
                  isNotRequired: true
                },
                invoicedTime: {
                  type: "checkbox",
                  isNotRequired: true
                },
                projectVisibilityFromD365: {
                  type: "checkbox",
                  isNotRequired: true
                },
                forcePowerUser: {
                  type: "checkbox",
                  isNotRequired: true
                },
                isIntegrationAdmin: {
                  type: "checkbox",
                  isNotRequired: true
                },
                isLocalAdmin: {
                  type: "radio",
                  isNotRequired: true
                },
                isAdmin: {
                  type: "radio",
                  isNotRequired: true
                },
                calcClientDataAccess: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcTemplatesAccess: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcTemplatesEditAccess: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcOfferBuilderAccess: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcGlobalBidsAccess: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcPgViewAccess:{
                  type: "checkbox",
                  isNotRequired: true
                },
                calcPgEditAccess: {
                  type: "checkbox_reliant",
                  reliantOn: "calcPgViewAccess",
                  isNotRequired: true
                },
                directOClogin: {
                  type: "checkbox",
                  isNotRequired: true
                },
                calcGlobalTenderManager: {
                  type: "checkbox",
                  isNotRequired: true
                }
              };
            }

            if (!this.is360FeatureFlag) {
              delete this.userFields.canAccess360View;
              delete this.newUserData.canAccess360View;
            }

            if(this.user.isLocalAdmin) {
              delete this.newUserData.canEditAccepted;
              delete this.newUserData.isLocalAdmin;
              delete this.newUserData.isAdmin;
              delete this.newUserData.isIntegrationAdmin;
              delete this.newUserData.calcGlobalBidsAccess;
              delete this.newUserData.canUpdateRates;
              delete this.newUserData.canViewRates;
              delete this.newUserData.canAccess360View;
              delete this.newUserData.canAccessFlexitime;
            }

            this.state = 'loaded';
            this.sideBarConfig = {
              "country": this.country,
              "team": this.team,
              "users": this.users,
              "clients": this.clientsOfTeam
            };

          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  // Add new user
  openUser(user) {
    this.$location.path('/admin/countries/' + this.country + '/team/' + this.teamId + '/user/' + user.id);
  }

  startAddingUser() {
    this.newUserValues = null;
    this.newUserValues = {
      teamId: this.teamId,
      mon: 0,
      tue: 0,
      wed: 0,
      thu: 0,
      fri: 0,
      sat: 0,
      sun: 0,
      canEditAccepted: false,
      canExportWorklog: false,
      canImportIncome: false,
      acceptPersonalWorklogs: false,
      canImportIncomeCountrywide: false,
      canUpdateRates: false,
      canViewRates: false,
      managementViewHidden: false,
      canAccess360View: false,
      canAccessFlexitime: false,
      isIntegrationAdmin: false,
      isLocalAdmin: false,
      isAdmin: false,
      calcClientDataAccess: false,
      calcTemplatesAccess: false,
      calcTemplatesEditAccess: false,
      calcOfferBuilderAccess: false,
      calcGlobalBidsAccess: false,
      calcPgViewAccess: false,
      calcPgEditAccess: false,
      directOClogin: false,
      restrictedClientAccess: false,
      calcGlobalTenderManager : false,
      invoicedTime: false,
      projectVisibilityFromD365: false,
      forcePowerUser: false,
    };
    this.newUserProcess = true;
  }

  checkInputsFunc(isEmployee) {
    let restrictedClientAccess = {
      type: "checkbox",
      isNotRequired: true,
    };
    if(isEmployee.key === "role" && isEmployee.value === "Employee") {
      this.newUserData = {...this.newUserData, restrictedClientAccess: restrictedClientAccess};
    }
    else if(isEmployee.key === "role") {
      delete this.newUserData.restrictedClientAccess; this.newUserValues.restrictedClientAccess = false;
    }
  }

  addUser(originalUser) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';
    let user = angular.copy(originalUser);

    if(user.standardWorkingHours === undefined){
      user.standardWorkingHours = 0;
    }

    if(!this.isFlexibleWorknormFF) {
      user.mon = user.standardWorkingHours;
      user.tue = user.standardWorkingHours;
      user.wed = user.standardWorkingHours;
      user.thu = user.standardWorkingHours;
      user.fri = user.standardWorkingHours;
    }

    user.worknorms =  [
      parseFloat(user.mon),
      parseFloat(user.tue),
      parseFloat(user.wed),
      parseFloat(user.thu),
      parseFloat(user.fri),
      parseFloat(user.sat),
      parseFloat(user.sun)
    ];

    delete user.mon;
    delete user.tue;
    delete user.wed;
    delete user.thu;
    delete user.fri;
    delete user.sat;
    delete user.sun;
    user.standardWorkingHours && delete user.standardWorkingHours;

    this.Admin.addUser(user).then(
      () => {
        this.init();
        this.newUserProcess = false;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }


  // Assign a client
  openClient(client) {
    this.$location.path('/admin/countries/' + this.country + '/team/' + this.teamId + '/client/' + client.id);
  }

  startAddingClient() {
    this.newClients = null;
    this.processesToAdd = this.processesToAdd.concat(this.suggestedProcessGroupConfig);
    this.newClientProcess = true;
  }

  cancelAssignClients() {
    this.newClientProcess = false;
    this.deselectAll();
    if (this.clientInternal) {
      this.clientInternal.selected = false;
    }
  }

  assignClients() {
    this.clientSearchText = '';
    if (this.clientInternal && this.clientInternal.selected) {
      this.newClients = { clientIds: [this.clientInternal.id] };
      this.processesToAdd = this.internalProcessGroupConfig;
    }
    else {
      this.newClients = { clientIds: this.clientsToAdd.filter(client => client.selected && (client.selected == true)).map(selectedClient => selectedClient.id) };
      this.processesToAdd = [].concat(this.suggestedProcessGroupConfig);
      this.processesToAdd = this.processesToAdd.concat(this.unusedProcessGroupConfig.filter( upgc => upgc.added == true));
    }
    this.showInternalPGC = this.clientInternal && !!this.clientInternal.selected;
    this.dropdownOpened = false;
  }

  toggleClientsAll() {
    this.clientsToAdd.forEach( client => this.allClientsSelected ? client.selected = true : client.selected = false);
    if (this.clientInternal && this.clientInternal.selected) {
      this.clientInternal.selected = false;
    }
  }

  deselectAll() {
    this.clientsToAdd.forEach( client => client.selected = false);
    this.allClientsSelected = false;
  }

  deselectAllWhenInternal() {
    if (this.clientInternal && this.clientInternal.selected) {
      this.deselectAll();
    }
  }

  deselect() {
    const clientsToAddSelected = this.clientsToAdd.filter( c => c.selected == true);
    if (this.clientInternal && this.clientInternal.selected) {
      this.clientInternal.selected = false;
    }
    if (clientsToAddSelected.length !== this.clientsToAdd.length) {
      this.allClientsSelected = false;
    } else {
      this.allClientsSelected = true;
    }
  }

  addProcess(proc) {
    this.processesToAdd.push(proc);
  }

  removeProcess(proc) {
    let tempProcesses = angular.copy(this.processesToAdd);
    tempProcesses.find( (p,i) => {
      if (p.groupConfiguration.id == proc.groupConfiguration.id) {
        this.processesToAdd.splice(i, 1);
      }
    });
  }

  addClient() {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    var client = angular.fromJson(this.newClients);
    client.configs = [];

    this.processesToAdd.map(p => {
      client.configs = client.configs.concat(p.processes);
    });
    client.configs.forEach(c => {
      if (!c.processId) {
        c.processId = c.id;
      }
      if (c.valueAdded == null) {
        c.valueAdded = c.valueAddedByDefault;
      }
      if (c.hasVolume == null) {
        c.hasVolume = c.hasVolumeByDefault;
      }
      if (c.commentRequired == null) {
        c.commentRequired = c.commentRequiredByDefault;
      }
      delete c.valueAddedByDefault;
      delete c.hasVolumeByDefault;
      delete c.commentRequiredByDefault;
      delete c.description;
      delete c.id;
      delete c.includeInReports;
      delete c.processGroupCountryConfigurationId;
      delete c.valueAddedByDefault;
      delete c.name;
    });
    this.Admin.addProcessForClientInTeam(this.teamId, client).then(
      () => {
        this.newClientProcess = false;
        this.deselectAll();
        this.clientSearchText = '';
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  removeClient(client) {
    this.modalConfig = {
      text: "ADMIN_CLIENTS.DELETE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };
    this.bModal.show(this.modalConfig).then(
      () => {
        this.Admin.removeClientFromTeam(this.teamId, client.id).then(
          () => {
            this.init();
          },
          (error) => {
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      (error) => {
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }


  //New overtime mode
  startAddingOvertime() {
    this.newOvertimeValues = null;
    this.newOvertimeProcess = true;
  }

  addOvertime(originalOvertime) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    let overtime = angular.copy(originalOvertime);
    overtime.teamId = this.teamId;

    this.Admin.setOvertimeMode(overtime).then(
      () => {
        this.init();
        this.newOvertimeProcess = false;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingOvertime(overtime) {
    this.editOvertimeProcess = true;
    this.editOvertimeValues = angular.copy(overtime);
    this.editOvertimeValues.mode = this.editOvertimeValues.managementMode;
  }

  updateOvertime(originalOvertime) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    let overtime = angular.copy(originalOvertime);
    delete overtime.managementMode;

    this.Admin.updateOvertime(overtime).then(
      ()=>{
        this.init();
        this.editOvertimeProcess = false;
      },
      (error)=>{
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  setColWidth(data, index, min = 10) {
    return data.reduce((width, row) => Math.max(width, row[index].length) , min);
  }

  exportClients() {
    const headers = ['CLIENT', 'TAX ID', 'COUNTRY', 'CLIENT GROUP NAME'];
    const data = this.clientsOfTeam.map(client => [client.name, client.taxId, client.country, client.clientGroupName || '']);
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, sheet, "Clients");
    XLSX.utils.sheet_add_aoa(sheet, [headers], { origin: "A1" });
    sheet["!cols"] = [ { wch: this.setColWidth(data, 0) }, { wch: this.setColWidth(data, 1) }, { wch: this.setColWidth(data, 2) }, { wch: this.setColWidth(data, 3, headers[3].length) } ];
    XLSX.writeFile(workbook, `Clients - ${this.team.name} - ${this.country} - ${moment().format('YYYY-MM-DD')}.xlsx`, { compression: true });
  }

  downloadClientNotes(client) {
    this.Admin.getClientNotes(client.id)
      .then((success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          'application/zip',
          `${client.name.replace(/\./g, '').toLowerCase()} process documentation`
        );
      }, (err) => {
        const message = String.fromCharCode.apply(null, new Uint8Array(err.data));

        this.Notes.postNote({
          type: "error",
          error: message.includes("Found zero notes for client")
            ? "Client has no notes."
            : "Something wrong happened. Try again later."
        });
      });
  }
}
